import Payment from '../../modules/Payment/Payment.jsx';
import Withdraw from '../../modules/Payment/Withdraw.jsx';
import { PaymentPageStyled } from '../../modules/Payment/styled/PaymentStyled.js';

function PagePayment() {
    return (
        <PaymentPageStyled>
            <Payment />
            <Withdraw />
        </PaymentPageStyled>
    );
}

export default PagePayment;
